import React from "react";
import {
  HelpCenterHitBase,
  TextWrapper,
  TitleWrapper,
  TitleText,
  Description,
  URL,
} from "./help-center-hits.styled";
import { helpCenterURLBase } from "../../../../utils/constants";
import { NoSearchContentItemBase } from "../search-content.styled";
import { trackSearchResultClicked } from "../../../../utils/analytics";
import { SiteSearchResults } from "../../config";
import * as FA from "../../../../styles/fontawesome";

export type HelpCenterHitType = {
  title: string;
  body_safe: string;
  vote_sum: number;
  id: string;
  objectID: string;
};

const HelpCenterHits = (props: SiteSearchResults) => {
  const hitURL = (id: string) => `${helpCenterURLBase}${id}`;

  return props?.hits?.length ? (
    <>
      {props?.hits?.map((hit, index) => (
        <HelpCenterHitBase key={hit.objectID}>
          <TextWrapper>
            {hit.title && hit.id && (
              <TitleWrapper
                // Uses page id to build correct HelpCenter URL
                href={hitURL(hit.id)}
                target="_blank"
                onClick={() => {
                  const resultType = props.query ? "page" : "noSearch";
                  trackSearchResultClicked(
                    hit.title,
                    props.index,
                    props.query,
                    hit,
                    props.queryID,
                    props.page,
                    resultType,
                    index
                  );
                }}
              >
                <TitleText>{hit.title}</TitleText>
                <URL>
                  <i css={FA.ArrowUpRightFromSquareRegular} /> {hitURL(hit.id)}
                </URL>
              </TitleWrapper>
            )}
            {hit.body_safe && <Description>{hit.body_safe}</Description>}
          </TextWrapper>
        </HelpCenterHitBase>
      ))}
    </>
  ) : (
    <NoSearchContentItemBase />
  );
};

export default HelpCenterHits;
